import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAreaChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 15.3226V21H19V5L12 12.7419L8 8.09677L2 15.3226Z",
		stroke: "var(--colors-grey-1)",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.5 2.75C2.5 2.33579 2.16421 2 1.75 2C1.33579 2 1 2.33579 1 2.75V21.25C1 21.6642 1.33579 22 1.75 22H20C20.4142 22 20.75 21.6642 20.75 21.25C20.75 20.8358 20.4142 20.5 20 20.5H2.5V2.75Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgAreaChart;
